import React, { useRef, useState } from "react";
import Slider from "react-slick";
import { MdArrowOutward } from "react-icons/md";

const UndergraduatePrograms = ({ openModal }) => {
    const sliderRef = useRef(null);
    const [progress, setProgress] = useState(0);

    const programs = [
        { title: "B.Tech in Computer Science Engineering", image: "/images/cs-student.webp" },
        { title: "B.Tech in Computer Science Engineering (AI)", image: "/images/btech-ai.webp" },
        { title: "B.Tech in Cyber Security", image: "/images/btech-cyber-security.webp" },
        { title: "B.Tech in Electronics & Communication Engineering", image: "/images/btech-elec-com.webp" },
        { title: "B.Tech in Civil Engineering", image: "/images/Civil-Engineering.webp" },
        { title: "B.Tech in Information Technology", image: "/images/btech-info-tech.webp" },
        { title: "B.Tech in AI & Data Science", image: "/images/btech-ai-data.webp" },
        { title: "B.Tech in Mechanical Engineering", image: "/images/btech-mach.webp" },
        { title: "B.Tech in Electrical Engineering", image: "/images/btech-elec.webp" }
    ];

    const settings = {
        infinite: true, // autoplay ke liye important
        speed: 800,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2500,
        pauseOnHover: true,
        arrows: false,

        beforeChange: (current, next) => {
            const totalSlides = programs.length;
            const percent = (next / (totalSlides - 1)) * 100;
            setProgress(percent);
        },

        responsive: [
            {
                breakpoint: 1400,
                settings: { slidesToShow: 3 }
            },
            {
                breakpoint: 992,
                settings: { slidesToShow: 2 }
            },
            {
                breakpoint: 768,
                settings: { slidesToShow: 1 }
            },
            {
                breakpoint: 576,
                settings: { slidesToShow: 1 }
            }
        ]
    };

    return (
        <section className="container-fluid section-bg ps-lg-5 ps-2 pe-2" style={{ padding: '36px 0px' }}>

            <div className="container">
                {/* Heading */}
                <h2 className="sub_heading text-center mb-0" style={{ fontWeight: "700" }}>
                    <span style={{
                        background: "linear-gradient(90deg, #000000 , #B40103 )",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent", fontWeight: "500", padding: "12px 0px"
                    }}>Undergraduate Programs Offered</span>
                </h2>

                <p style={{
                    background: "linear-gradient(90deg, #B40103, #4E0001)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent", fontWeight: "500", padding: "12px 0px"
                }} className="mb-0 text-center">
                    Best B.Tech - Four Year Program in Jaipur
                </p>
                <div className="row">
                    <div className="col-lg-3"></div>
                    <div className="col-lg-6">
                        <p className="mb-lg-4 text-center" style={{ fontSize: "14px", color: '#323232' }}>
                            Arya College BTech Admission, accepting applications across engineering branches such as Computer Science, Mechanical, Civil, and several other specialisations.
                        </p>
                    </div>
                    <div className="col-lg-3"></div>
                </div>
                <div className="pe-lg-4 pe-0">
                    {/* Slider */}
                    <Slider ref={sliderRef} {...settings}>
                        {programs.map((program, index) => (
                            <div key={index} className="px-2">
                                <div
                                    className="p-3"
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        height: "337px",
                                        background: "#fff",
                                        borderRadius: "15px",
                                        boxShadow: "0 4px 20px rgba(0,0,0,0.08)"
                                    }}
                                >
                                    <img
                                        src={program.image}
                                        alt={program.title}
                                        className="img-fluid"
                                        style={{
                                            height: "200px",
                                            width: "100%",
                                            objectFit: "cover",
                                            borderRadius: "12px"
                                        }}
                                    />

                                    <h6 className="mt-3 mb-3" style={{ fontWeight: "600" }}>
                                        {program.title}
                                    </h6>

                                    <div className="d-flex" style={{ marginTop: 'auto' }}>
                                        <button
                                            className="btn"
                                            style={{
                                                background: "#E30613",
                                                color: "#fff",
                                                borderRadius: "8px",
                                                fontSize: "14px"
                                            }}
                                            onClick={() => openModal("Apply Now")}
                                        >
                                            Apply Now <MdArrowOutward />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>


                {/* Progress Bar */}
                <div
                    style={{
                        width: "100px",
                        height: "5px",
                        background: "#ddd",
                        borderRadius: "10px",
                        margin: "20px auto",
                        overflow: "hidden",
                    }}
                >
                    <div
                        style={{
                            width: `${progress}%`,
                            height: "100%",
                            background: "#EC9C9F",
                            transition: "0.4s ease"
                        }}
                    ></div>
                </div>

            </div>
        </section>
    );
};

export default UndergraduatePrograms;